// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// project import
import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Notification from './Notification';
import FullScreen from './FullScreen';
import MobileSection from './MobileSection';
import AdminButton from './AdminButton';

import PharoIcon from './PharoIcon';
import OrdersIcon from './OrdersIcon';
import NavToggle from './NavToggle';
import { QuestionOutlined } from '@ant-design/icons';

import React, { useRef, useEffect } from 'react';
import { isDesktopShell } from 'utils/isDesktopShell';
import { getCurrentAppType } from 'utils/dynamicConfig';

interface HeaderContentProps {
  onOpenShortcutsModal?: () => void;
}

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent({ onOpenShortcutsModal }: HeaderContentProps) {
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const shell = isDesktopShell();
  const appType = getCurrentAppType();
  const isOpsDomain = appType.includes('ops');

  return (
    <>      
      <PharoIcon />
      {/* <OrdersIcon /> */}
      <NavToggle />
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      
      {/* hidden on mobile unless in desktop shell, and hidden for ops domains */}
      {(!downLG || shell) && !isOpsDomain && (
        <Tooltip title="Keyboard Shortcuts (Ctrl+?)">
          <IconButton
            color="secondary"
            onClick={onOpenShortcutsModal}
            sx={{ color: 'text.primary' }}
          >
            <QuestionOutlined />
          </IconButton>
        </Tooltip>
      )}
      
      <AdminButton />
      <Notification />
      {/* <Message /> */}
      {/* {!downLG && <FullScreen />} */}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
